// app status
import { createSlice } from "@reduxjs/toolkit";
import { HYDRATE } from "next-redux-wrapper";

interface ISiteInfo {
  isInPostArea: boolean;
  isNeedRedirect: boolean;
}

interface IApp {
  fonts: string; // fonts
  isMobile: boolean; // is mobile device, when client width less than 1024px
  isSmallScreen: boolean; // is small device, when client width less than 768px
  site: string | null;
  countryCode: string;
  siteInfo: ISiteInfo | null; // /front/site-info 返回结果，缓存避免重复请求
}

const initialState: IApp = {
  fonts: "font-en",
  isMobile: false,
  isSmallScreen: false,
  site: null,
  countryCode: "CN",
  siteInfo: null,
};

const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setFonts: (state, action) => {
      state.fonts = action.payload;
    },
    setIsMobile: (state, action) => {
      state.isMobile = action.payload;
    },
    setIsSmallScreen: (state, action) => {
      state.isSmallScreen = action.payload;
    },
    setSite: (state, action) => {
      state.site = action.payload;
    },
    setCountryCode(state, action) {
      state.countryCode = action.payload;
    },
    setSiteInfo(state, action) {
      state.siteInfo = action.payload;
    },
  },
  extraReducers: {
    // hydrated 用于获取服务端注入的state并选择更新
    [HYDRATE]: (state, action) => {
      return {
        ...state,
        ...action.payload.app,
      };
    },
  },
});

export const { setFonts, setIsMobile, setIsSmallScreen, setSite, setCountryCode, setSiteInfo } = appSlice.actions;
export default appSlice.reducer;
